import helper from '@/libs/forms';

export default {
  schema: {
    fields: [
      helper.switch(
        'I want to receive e-mail notifications from Anchor Marketing',
        'optIn', false, 'Yes', 'No', 'col-md-12',
      ),
    ],
  },
  options: helper.options('contact-opt-', false),
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/contact/schemas/opt.js